'use strict';

let $ = require('jquery');

import * as _ from 'lodash';
import App from 'App';
import Server from 'server/Server';

import GroupView from 'views/record/Group';
import {FieldFactory} from 'factory/FieldFactory';
import Context from 'models/context/Context';
import User from 'User';

import FieldClickRequest from '../../server/protocol/request/task/FieldClick';
import FieldChangeRequest from '../../server/protocol/request/task/FieldChange';
import { SAIView } from '../../Additions';

import LoadingMask from 'views/loading/LoadingMask';
import { Group } from '../../parametrage/structures/Group';
import FieldView from './Field';
import { FieldInstance, FieldValidityLevel } from '../../parametrage/structures/FieldInstance';
import DeviceUtils from '../../utils/DeviceUtils';
import { Field } from '../../parametrage/structures/Field';
import { Task } from '../../parametrage/structures/Task';
import { PageInstance } from '../../parametrage/structures/PageInstance';
import { TaskRequest } from '../../server/protocol/request/task/TaskRequest';
import { Panel } from '../../parametrage/structures/Panel';
import NotificationManager from '../../utils/notification/NotificationManager';
import { Note } from '../../models/Note';

class RecordView extends SAIView {
    public groups : Array<GroupView>;
    private groupsMap: {[groupId:string]: GroupView};
    private contextType : any;
    private domainContext: any;
    private dossierKeys: any;
    private groupsConfig : Array<Group>;
    private taskConfig: Task;
    private dominantColor: string;
    private displayMode: string;
    private fields: {[propId: string]: FieldView};
    private enabled: boolean;
    private panelId: string;
    private hasPendingFieldChange: boolean;
    private eventsBinded: boolean;

    constructor(options?: any) {
        super(options);
        this.domainContext = options.domainContext;
        this.contextType = options.contextType || 'record';
        this.dominantColor = options.dominantColor;
        this.displayMode = options.displayMode;
        this.taskConfig = options.taskConfig;

        this.checkMandatoryParameter(options, 'domainContext', 'The execution context of the component');
        this.checkMandatoryParameter(options, 'displayMode', 'tablet or desktop based on screen size and context');

        this.template = require('templates/Record.ejs');
        this.groups = [];
        this.groupsMap = {};
        this.enabled = options.enabled !== undefined ? options.enabled : true;
        if (options.groups) {
            this.setGroups(options.groups);
        }
        this.panelId = options.panelId;
        this.eventsBinded = false;
    }

    setKeys(keys: any) {
        this.dossierKeys = keys;
    }

    setDominantColor(color) {
        this.options.dominantColor = color;
        if(this.groups.length > 0){
            for(var key in this.groups){
                this.groups[key].setDominantColor(color);
            }
        }
    }

    /**
     * The goal of this function is to update all the field instances with the
     * proper values and positioning
     * @param groups The list of instance groups
     */
    public setValuesAndPositions(groups: Array<Group>, renderModifications?:boolean): void {
        for(let key in groups) {
            let curGrpFields = groups[key].getFields();
            for(let fKey in curGrpFields) {
                this.setField(curGrpFields[fKey], renderModifications);
            }
            if(renderModifications) {
                this.groupsMap[groups[key].getId()].moveFieldsToPositions();
            }
        }
    }

    public getField(id: string): FieldView {
        return this.fields[id];
    }

    public getFieldByDatafieldId(datafieldId : string) : FieldView {
        for(let i in this.fields) {
            let fieldConfig = this.fields[i].getConfig();
            if(fieldConfig.getDatafieldId() === datafieldId) {
                return this.fields[i];
            }
        }
        return undefined;
    }

    setField(field: Field, renderModifications: boolean, discardPositions?: boolean) {
        if(field.getId() === 'EDMSDESCRIPTOR_1') {
            return;
        }
        let fieldView = this.fields[field.getId()];
        if (fieldView) {
            let finalValue;
            if(fieldView.getConfig().getPermanentValue() !== undefined) {
                finalValue = fieldView.getConfig().getPermanentValue();
            } else if(fieldView.getConfig().getLinkedDataField().getPermanentValue() !== undefined) {
                finalValue = fieldView.getConfig().getLinkedDataField().getPermanentValue();
            } else {
                if(App.getActionMode() === 'newEntry') {
                    finalValue = field.getValue() === '' ? fieldView.getValue() : field.getValue();
                } else {
                    finalValue = field.getValue();
                }
                //finalValue = field.getValue() === '' ? fieldView.getValue() : field.getValue();
            }
            fieldView.setModelValue(fieldView.parseValue(finalValue));
            fieldView.setNotes(Note.buildNoteArray(field.getConfig().notes));
            if(!discardPositions) {
                fieldView.setEnabled(field.isEnabled() && this.enabled);
                fieldView.setVisible(field.isVisible(this.displayMode));
                fieldView.setReadOnly(field.isReadOnly() ? 'true' : 'false');
            }
            fieldView.setLabel(field.getLabel());
            if(renderModifications) {
                fieldView.getState().setValidityLevel(FieldValidityLevel.VALID);
                fieldView.render();
                let initialContext = new Context();
                initialContext.setContextId(this.panelId ? 'record' : 'page');
                this.onContextRecordRequest(initialContext, true);
                fieldView.onDOMUpdated(initialContext);
            }
        } else {
            throw new Error('Unknown field in screen ' + field.getId() + ' with datafield ' + field.getDatafieldId());
        }
    }

    setGroups(groupsConfig) {
        this.groupsConfig = groupsConfig;
        this.clearCurrentGroups();

        for (var key in this.groupsConfig) {
            var newGroup = this.groupsConfig[key];
            var newView = new GroupView({
                displayMode: this.parameters['displayMode'],
                groupConfig: newGroup,
                taskId: newGroup.getPanel().getParentTask().getId(),
                dominantColor: this.dominantColor,
                domainContext: this.domainContext,
                enabled: this.enabled
            });
            this.groups.push(newView);
            this.groupsMap[newView.getConfig().getId()] = newView;
            Object.assign(this.fields, newView.getFields(function(){return true;}).reduce(function(acc, cur, i) {
                acc[cur.getState().getId()] = cur;
                return acc;
            }, {}));
        }
    }

    clearCurrentGroups() {
        this.groups = [];
        this.fields = {};
    }

    render() : any {
        this.checkInitialized();

        this.$el.addClass('recordView');
        this.$el.addClass(this.parameters['displayMode']);

        this.$el.html(this.template({
        }));

        //Removing all groups before re-rendering
        this.$el.find('.innerRecord').empty();

        if (this.groups && this.groups.length > 0) {
            this.renderGroups();

            var allClickableFields = this.getFields(function (field: FieldView) {
                return field.canBeClick();
            });
            for (var key in allClickableFields) {
                this.stopListening(allClickableFields[key], 'fieldClick');
                this.listenTo(allClickableFields[key], 'fieldClick', this.onFieldClick.bind(this));
            }

            var allChangeableFields = this.getFields(function (field: FieldView) {
                return field.canBeChange();
            });

            for (var key2 in allChangeableFields) {
                this.stopListening(allChangeableFields[key2], 'fieldChange');
                this.listenTo(allChangeableFields[key2], 'fieldChange', this.onFieldChange.bind(this));
            }

            var allContextCallable = this.getFields(function (field: FieldView) {
                let type = field.getConfig().getObjectTypeFromFormatPresentation();
                return type === 'Couple' || type === 'ListCouple';
            });

            for (var coupleKey in allContextCallable) {
                this.stopListening(allContextCallable[coupleKey], 'panel.onPrepareContext');
                this.stopListening(allContextCallable[coupleKey], 'panel.onPrepareScriptContext');
                this.listenTo(allContextCallable[coupleKey], 'panel.onPrepareContext', this.onContextRecordRequest.bind(this));
                this.listenTo(allContextCallable[coupleKey], 'panel.onPrepareScriptContext', this.onContextScriptRequest.bind(this, false, true));
            }

            var allContextClickable = this.getFields(function (field: FieldView) {
                let type = field.getConfig().getObjectTypeFromFormatPresentation();
                return type === 'Link';
            });
            if(!this.eventsBinded) {
                this.eventsBinded = true;
                for(var linkKey in allContextCallable) {
                    this.listenTo(allContextClickable[linkKey], 'linkclicked', this.onLinkClick.bind(this));
                }
            }
        }

        var fields = this.getFields(function(){return true;});
        for(var fieldId in fields){
            this.stopListening(fields[fieldId], 'requestFocus');
            this.stopListening(fields[fieldId], 'restrictionRequest');
            this.listenTo(fields[fieldId], 'requestFocus', this.onRequestFocus.bind(this));
            this.listenTo(fields[fieldId], 'restrictionRequest', this.onRestrictionRequest.bind(this));
        }
    }

    private onRestrictionRequest(props) {
        props.fieldChange = this.hasPendingFieldChange;
    }

    private onLinkClick(config: Field) {
        let datafield = config.getLinkedDataField();
        let notification = datafield.getNotificationOnClick();
        if(notification) {
            let taskMap = { task: undefined };
            this.trigger('record.taskContext', taskMap);
            let notificationManager = new NotificationManager({
                currentTaskContext: taskMap.task,
                domainContext: this.domainContext,
                contextFiller: this.fillNotificationOnClickContext.bind(this, config)
            })
            notificationManager.handle(notification);
        }
    }

    private fillNotificationOnClickContext(field: Field, context: {[propId: string]: string}) {
        this.trigger('record.onPrepareScript', context, this.panelId, false);
        context['currentFieldId'] = field.getId();
        context['currentDatafieldId'] = field.getDatafieldId();
    }

    onRequestFocus(evt){
        if(DeviceUtils.isMobile()){
            if($(evt.delegateTarget).offset().top > 0){
                this.$el.parent().scrollTop($(evt.delegateTarget).offset().top - this.$el.offset().top - 10);
            }
        }
    }

    onContextRecordRequest(context: Context, needsAllPanels: boolean) {
        context.setContextId(this.contextType);
        if(this.contextType === 'page') {
            var values = this.getFieldsValues();
            context.addFields(values);
            for(var key in this.dossierKeys){
                context.addParameter(key, this.dossierKeys[key]);
            }
        } else {
            if(!this.panelId){ throw new Error('Missing panelId in record definition');}
            if(needsAllPanels) {
                //We trigger the upper level, as there might be multiple panels to send
                this.trigger('record.onPrepareContext', context, this.panelId);
            } else {
                var values = this.getFieldsValues();
                context.addPanelFields(values, this.panelId);
            }
        }
    }

    public getScriptContext(withDollar: boolean): {[propId:string]: string} {
        if(withDollar === undefined) {
            withDollar = true;
        }
        let context = {};
        let fields = {};
        var values = this.getFieldsValues();
        for(let id in values) {
            fields[values[id].key] = values[id].value;
        }
        let allFields: Array<FieldView> = this.getFields(function(){ return true;});
        for(let id in allFields) {
            let config: Field = allFields[id].getConfig();
            let datafieldId;
            if(config.isCouple() && config.isCoupleKey()) {
                datafieldId = (withDollar && config.getValue().indexOf('$') === -1 ? '$' : '') + config.getValue();
            } else {
                if(withDollar) {
                    datafieldId = (config.getDatafieldId().indexOf('$') === -1? '$' : '') + config.getDatafieldId();
                } else {
                    datafieldId = config.getDatafieldId();
                }
            }
            if(datafieldId.startsWith('$') && !withDollar) { datafieldId = datafieldId.slice(1); }
            if(datafieldId.indexOf('.') < 0) {
                context[datafieldId] = fields[config.getId()];
            } else {
                let splitted = datafieldId.split('.');
                let root = context;
                for(let i in splitted) {
                    let child = splitted[i];
                    if(root[child] === undefined) {
                        root[child] = {};
                    }
                    if(splitted.indexOf(child) === splitted.length - 1) {
                        root[child] = fields[config.getId()];
                    } else {
                        root = root[child];
                    }
                }
            }
            //context[(withDollar ? '$' : '') + config.getDatafieldId()] = fields[config.getId()];

            context[(withDollar ? '$' : '') + config.getId()] = fields[config.getId()];
        }

        this.trigger('record.onPrepareScriptContext',context, withDollar);

        return context;
    }

    onContextScriptRequest(needsAllPanels: boolean, needsDollarsPrefix: boolean, context: {[propId: string]: string}) {
        if(this.contextType === 'page') {
            _.merge(context, this.getScriptContext(needsDollarsPrefix));

        } else {
            if(!this.panelId){ throw new Error('Missing panelId in record definition');}
            if(needsAllPanels) {
                //We trigger the upper level, as there might be multiple panels to send
                this.trigger('record.onPrepareScript', context, this.panelId, needsDollarsPrefix);
            } else {
                _.merge(context, this.getScriptContext(needsDollarsPrefix));
            }
        }
    }

    setRequestRecordContext(request: TaskRequest, sendAllPanels: boolean) {
        var recordContext = new Context();
        this.onContextRecordRequest(recordContext, sendAllPanels);
        if(this.contextType === 'page'){
            request.setPageContext(recordContext);
            for(var key in this.dossierKeys){
                recordContext.addParameter(key, this.dossierKeys[key]);
            }
        }else{
            request.setRecordContext(recordContext);
        }
    }

    setRequestKeyContext(request: TaskRequest) {
        let taskKeyContext = new Context();
        this.trigger('record.onPrepareKeyContext', taskKeyContext);
        request.setKeyContext(taskKeyContext);
    }

    onFieldClick(fieldData, sendAllPanels: boolean) {
        var recordValues = this.getFieldsValues();
        //Allow to modify the values if needed before sending them to the server
        let clickRequest = new FieldClickRequest(this.domainContext, this.options.taskId);
        clickRequest.setFieldId(fieldData.getConfig().id);
        this.setRequestRecordContext(clickRequest, sendAllPanels);
        this.setRequestKeyContext(clickRequest);

        let loadingReqId;
        LoadingMask.requestLoading('Chargement...')
            .then((reqId) => {
                loadingReqId = reqId;
                return Server.performRequest(clickRequest);
            })
            .then(this.onFieldResult.bind(this, 'Click', sendAllPanels, fieldData))
            .catch(App.displayErrorMessage)
            .then(function(){ LoadingMask.hide(loadingReqId);});
    }

    onFieldChange(fieldData: FieldInstance, sendAllPanels: boolean, promises: Array<Promise<any>>, forced?: boolean) {
        // Don't call the onFieldChange if the field is not enabled
        if(fieldData.isEnabled() || forced) {
            this.hasPendingFieldChange = true;
            //Allow to modify the values if needed before sending them to the server
            let changeRequest = new FieldChangeRequest(this.domainContext, this.taskConfig.getId());
            changeRequest.setFieldId(fieldData.getId());
            changeRequest.setInitialValue(fieldData.getInitialValue());
            changeRequest.setLastNonEmptyValue(fieldData.getLastNonEmptyValue());
            changeRequest.setLastValue(fieldData.getLastValue());

            this.setRequestRecordContext(changeRequest, sendAllPanels);
            this.setRequestKeyContext(changeRequest);
            promises.push(new Promise((accept, reject) => {
                let loadingReqId;
                LoadingMask.requestLoading('Chargement...')
                    .then((reqId) => {
                        loadingReqId = reqId;
                        return Server.performRequest(changeRequest);
                    })
                    .then((result) => {
                        this.onFieldResult('Change', sendAllPanels, fieldData, result, forced);
                        accept(undefined);
                    })
                    .catch((error) => {
                        App.displayErrorMessage(error);
                        reject();
                    })
                    .then(() => {
                        this.hasPendingFieldChange = false;
                        LoadingMask.hide(loadingReqId);
                    });
            }));
        }
    }

    onFieldResult(type, sendAllPanels: boolean, fieldData: FieldInstance, result, forced?: boolean) {
        var allFields = this.getFields(function (field) {
            return field['canBe' + type]();
        });

        for (var key in allFields) {
            this.stopListening(allFields[key], 'field' + type);
        }
        if(this.contextType === 'page') {
            let newPage = new PageInstance(result.screen, this.taskConfig, null, this.domainContext);
            this.setValuesAndPositions(newPage.getGroups());
            this.render();
            this.expandGroups();
        } else {
            if(sendAllPanels) {
                this.trigger('record.updateRecordsRequest', result.task);
            } else {
                let curPan = new Panel(result.task.screen[0], this.taskConfig, this.domainContext);
                this.setValuesAndPositions(curPan.getGroups());
                this.render();
            }
        }
        let fieldView = this.getField(fieldData.getId());
        let nextField = this.getNextField(fieldView);
        if(nextField !== undefined && !forced) {
            nextField.focus();
        }
    }

    public getGroup(groupId: string) {
        return this.groupsMap[groupId];
    }

    public getGroups() : Array<GroupView> {
        return this.groups;
    }

    expandGroups(){
        var maxKey = 0;
        var rowMap = {};
        for (var key in this.groups) {
            var currentGroup = this.groups[key];
            var row = currentGroup.getConfig().getPosition(this.displayMode).row;
            if(!rowMap[row]){
                rowMap[row] = [];
            }
            rowMap[row].push(currentGroup);
            maxKey = Math.max(row, maxKey);
        }

        if(this.groups.length === 1){
            this.groups[0].$el.css({
                width: '100%',
                height: '100%'
            });
        }else if(this.groups.length > 0){
            for(var rowMapKey in rowMap){
                if(rowMap[rowMapKey].length === 1){
                    //Only one group in this index, we can expand it to take full width
                    rowMap[rowMapKey][0].$el.css({
                        width: '100%'
                    });
                }
            }

            var bottomElements = rowMap[maxKey];
            var maxHeightGroup;
            var maxHeight = 0;
            for(var grpKey in bottomElements){
                var previous = maxHeight;
                let curGrpHeight = bottomElements[grpKey].$el.height();
                maxHeight = Math.max(maxHeight, curGrpHeight);
                if(maxHeight !== previous){
                    maxHeightGroup = bottomElements[grpKey];
                }
            }

            var recordStart = this.$el.offset().top;
            var lastGroupStart = maxHeightGroup.$el.offset().top - recordStart;
            var finalHeight;

            if(lastGroupStart + maxHeight <= this.$el.height()){
                // The group is missing some px to be at bottom
                var curPad = this.$el.css('padding-top');
                if(curPad && curPad.endsWith('px')) {
                    curPad = curPad.substring(0, curPad.length - 2);
                }else{
                    curPad = '0';
                }
                finalHeight = this.$el.height() - lastGroupStart + parseInt(curPad);
            }else{
                finalHeight = maxHeight;
            }

            for(var grpToUpKey in bottomElements){
                bottomElements[grpToUpKey].$el.height(finalHeight);
            }
        }
    }

    renderGroups() {
        var holder = this.$el.find('.innerRecord');
        for (var key in this.groups) {
            var currentGroup = this.groups[key];
            var newGroupEl = $('<fieldset>').appendTo(holder);
            currentGroup.setElement(newGroupEl);
            currentGroup.render();
        }
        this.moveGroupsToPositions();
    }

    moveGroupsToPositions() {
        for (var key in this.groups) {
            var currentGroup = this.groups[key];
            currentGroup.$el.css(FieldFactory.locateGroupinPanel(this, currentGroup, this.options.displayMode));
        }
    }

    getFieldsValues() {
        var finalOutput = [];
        for (var grpKey in this.groups) {
            var currentGrpOutput = this.groups[grpKey].getFieldsValues();
            for (var key in currentGrpOutput) {
                let curField = currentGrpOutput[key];
                var newField = {
                    key: key,
                    value: this.evalInContext(curField.value),
                    enabled: curField.enabled,
                    visible: curField.visible
                };
                if (currentGrpOutput[key].notes) {
                    newField['notes'] = currentGrpOutput[key].notes;
                }
                finalOutput.push(newField);
            }
        }
        return finalOutput;
    }

    getGroupsBoundaries() {
        var finalBounds = {
            min: Number.MAX_VALUE,
            max: 0
        };

        for (var grpKey in this.groups) {
            var current = this.groups[grpKey];
            finalBounds.min = Math.min(finalBounds.min, current.getFieldMinLeft());
            finalBounds.max = Math.max(finalBounds.max, current.getFieldMaxLeft());
        }

        return finalBounds;
    }

    getFields(filter) : Array<FieldView>{
        var allFields = [];
        for (var grpKey in this.groups) {
            allFields = allFields.concat(this.groups[grpKey].getFields(filter));
        }
        return allFields;
    }

    setDisplayMode(mode) {
        this.parameters['displayMode'] = mode;
    }

    resize(mode, optHeight) {
        if (mode === 'desktop') {
            if (optHeight) {
                this.$el.css({
                    height: optHeight
                });
            }
        }
    }

    getMaxHeight() : number {
        let maxHeight : number = 0;
        for (var grpKey in this.groups) {
            let current = this.groups[grpKey];
            let curHeight = current.$el.offset().top + current.$el.outerHeight();
            if(curHeight > maxHeight) {
                maxHeight = curHeight;
            }
        }
        return maxHeight;
    }

    getTotalHeight() : number {
        let totalHeight : number = 0;
        for (var grpKey in this.groups) {
            let current = this.groups[grpKey];
            totalHeight += current.$el.outerHeight(true);
        }
        return totalHeight;
    }

    getMaxWidth() : number {
        let maxWidth : number = 0;
        for (var grpKey in this.groups) {
            let current = this.groups[grpKey];
            if (current.$el.width() > maxWidth) {
                maxWidth = current.$el.width();
            }
        }
        return maxWidth;
    }

    setEnabled(enabled: boolean) {
        this.enabled = enabled;
    }

    public validate() {
        let hasInvalid = false;
        for(let key in this.fields) {
            if(!this.fields[key].validate()) {
                hasInvalid = true;
            }
        }
        return !hasInvalid;
    }

    public hasInvalidFields() {
        for(let key in this.fields) {
            if(!this.fields[key].getState().isUserValid()) {
                return true;
            }
        }
        return false;
    }

    public moveToField(fieldId: string) {
        if(fieldId) {
            let field = this.fields[fieldId];
            this.$el.animate({
                scrollTop: field.$el.offset().top
            });
        }
    }

    public getInvalidField() {
        for(let key in this.fields) {
            if(!this.fields[key].getState().isUserValid()) {
                return key;
            }
        }
        return null;
    }

    private getNextField(currentField: FieldView) : FieldView {
        let fieldList = this.getFields(null);
        let nextFieldIndex = fieldList.indexOf(currentField) + 1;
        let nextField = undefined;
        if(nextFieldIndex > 0 && nextFieldIndex < fieldList.length) {
            while(nextFieldIndex < fieldList.length) {
                nextField = fieldList[nextFieldIndex];
                if(nextField.$el.is(':visible')) {
                    break;
                } else {
                    nextFieldIndex ++;
                }
            }
        }
        if(nextFieldIndex === 0 || nextFieldIndex === fieldList.length) {
            // Next field not found --> keep the current field
            nextField = currentField;
        }
        return nextField;
    }

    private evalInContext(expression:String):any {
        if(expression !== null && expression !== undefined && expression.startsWith('$')) {
            const field = this.getFieldByDatafieldId(expression.substr(1));
            if(field && field.getFieldValue()) {
                return field.getFieldValue();
            } else {
                return '';
            }
        } else {
            return expression;
        }
    }
}

export default RecordView;
